import React, { Component } from "react";
import IframeProcessor from "../lib/IframeProcessor";

class GatewayForm extends Component {
  render() {
    const {
      country,
      userAccountInfo,
      leadFormKey,
      encryptedAccountNumber,
      leadCapturePatdotUrl,
      isPardotTrueExist,
      isFormlessForm,
      pardotURLForSelectedSlugId,
      isECMLive
    } = this.props;

    let pardotURL = undefined;
    if(isECMLive === 'true') {
      if (leadCapturePatdotUrl !== undefined && !isPardotTrueExist) {
        pardotURL = leadCapturePatdotUrl;
      } else {
        pardotURL = undefined;
      }
    } else {
        pardotURL = pardotURLForSelectedSlugId !== undefined && !isPardotTrueExist ? pardotURLForSelectedSlugId : undefined;
    }

    const gatewayFormMainContainerCustomStyle = !isFormlessForm
      ? {
          overflow: "hidden",
          position: "relative",
          backgroundColor: "#7f899c",
          boxShadow: "0px -38px 116px -33px rgba(14, 13, 14, 0.53)",
        }
      : null;

    if (
      leadFormKey === "Y" &&
      (country.toLowerCase() === "us" || country.toLowerCase() === "ca")
    ) {
      if (pardotURL !== undefined) {
        return (
          <div className="gatewayFormMainContainer">
            <div
              className="gatewayFormSubContainer"
              style={gatewayFormMainContainerCustomStyle}
            >
              <div className="headSection">
                <h2>
                  {" "}
                  Provide your information to gain instant access to the full
                  report
                </h2>
              </div>
              <IframeProcessor
                className="pardotFormIframe"
                customStyle={null}
                countryCode={country.toUpperCase()}
                content={{
                  pardotUrl: pardotURL,
                  iframeTitle: "pardot-brc-form-capture-lead",
                }}
                userType={userAccountInfo}
                encryptedAccountNumber={encryptedAccountNumber}
              />
            </div>
          </div>
        );
      } else {
        return null;
      }
    } else {
      return null;
    }
  }
}

export default GatewayForm;
